<template>
  <div class="home flex-grow flex justify-center items-center">
    <div class="container mx-auto px-4 text-center">
      <h1 class="uppercase text-3xl font-display text-blue-500">valForm</h1>
      <p class="mb-3">form validation library</p>
      <p
        class="italic text-xs"
      >lightweight (26kb minified, 8kb gzipped), fully customizable, no dependencies</p>

      <p class="mt-10">
        <a class="px-3 py-2 rounded bg-blue-600 text-white text-sm hover:bg-blue-700" target="_blank" href="https://unpkg.com/valform/dist/index.js" >Download</a>
      </p>

      <p class="text-xs">or</p>

      <p class="mb-10">
        <span class="px-3 py-2 bg-gray-200 text-sm font-monospace">npm install valform</span>
      </p>

      <p>
        <router-link class="mr-5 text-blue-600" to="/docs">docs</router-link>
        <router-link class="mr-5 text-blue-600" to="/demo">demo</router-link>
        <a
          target="_blank"
          href="https://github.com/radoslavtomas/valForm"
          class="text-blue-600"
        >github</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {
    // HelloWorld
  }
};
</script>
